<template>
    <div class="right text-right xl:mt-0 md:mt-spc20">
        <ul class="social flex items-center xl:justify-end md:justify-start">
            <li class="mr-2">
                <a href="https://facebook.com"
                   class="w-10 h-10 block bg-whitelight text-white text-center rounded-full pt-spc15 hover:bg-primary hover:text-white">
                    <font-awesome-icon :icon="['fab', 'facebook-f']" class="ml-auto mr-auto w-3" />
                </a>
            </li>
            <li>
                <a href="https://facebook.com"
                   class="w-10 h-10 block bg-whitelight text-white text-center rounded-full pt-spc15 hover:bg-primary hover:text-white">
                    <font-awesome-icon :icon="['fab', 'twitter']" class="ml-auto mr-auto w-3" />
                </a>
            </li>
        </ul>
        <p class="footer-copyright mt-spc10">
            <a :href="cpmenu.path" class="text-size10 text-whitelight font-medium hover:text-paragraph" v-for="(cpmenu, index) in copyrightmenu" :key="index" :class="cpmenu.classname">
                {{cpmenu.title}}
            </a>
            <span class="text-size10 text-whitelight font-medium ml-spc6">
                &copy; {{copyText}}
            </span>
        </p>
    </div>
</template>

<script>
    export default {
        name: "FooterRight",
        data() {
            return {
                copyrightmenu: [
                    {
                        path: '#',
                        title: 'Terms & Conditions',
                        classname: '',
                    },
                    {
                        path: '#',
                        title: 'Privacy Policy',
                        classname: ' ml-spc6 ',
                    }
                ],
                copyText: '2020 Jekyll Themes'
            }
        }
    }
</script>

<style scoped>

</style>